// TODO: rename DocumentActionsCellRenderer
import React, { useState, useEffect } from "react"
import "./document-actions.scss"

// context
import useDocuments from "context/hooks/useDocuments"
import useStudy from "context/hooks/useStudy"
import useChecklists from "context/hooks/useChecklists"

// utils
import useDownloadFile from "components/files/fileUtils"

const DocumentActions = ({
  data,
  source,
  documents,
  checklist,
  checklistDetails,
  rowIndex,
  className,
  iconsClassName,
}) => {
  const { downloadFile } = useDownloadFile()
  const { onOpenPanel } = useStudy()

  const { setSelectedDocument, onOpenPdf } = useDocuments()

  const { setSelectedChecklist, setSelectedOption } = useChecklists()

  const [document, setDocument] = useState(null)

  useEffect(() => {
    if (source === "checklist") {
      let foundDocument = documents.find(
        (doc) => doc.name === data.document_name && doc.document_type_name === data.document_type_name
      )
      setDocument(foundDocument)
    }
  }, [documents])

  const openPanel = () => {
    if (source === "checklist") {
      let foundOption = checklistDetails?.options?.find((option) => option.id === data.id)
      setSelectedChecklist(checklist)
      setSelectedOption(foundOption)
      setSelectedDocument(document)
      onOpenPanel("document-details")
    } else {
      setSelectedDocument(data)
      onOpenPanel("document-details")
    }
  }

  const renderOpenDownloadButton = () => {
    const file = source === "checklist" ? document : data
    if (file?.document_link) {
      // open tab for links
      return (
        <i
          className={`fal fa-external-link${iconsClassName ? ` ${iconsClassName}` : ""}`}
          onClick={() => window.open(file.document_link)}
        />
      )
    }
    // for PDFs show open icon and open PDFTron
    // else if (
    //   file?.document_file &&
    //   // file.document_file.toLowerCase().includes(".pdf") ||
    //   (file.document_file.toLowerCase().includes(".doc") || file.document_file.toLowerCase().includes(".docx"))
    // ) {
    //   return (
    //     <i
    //       className={`fal fa-external-link${iconsClassName ? ` ${iconsClassName}` : ""}`}
    //       onClick={() => onOpenPdf(file)}
    //     />
    //   )
    // }
    // download all other file types
    else {
      return (
        <i
          className={`fal fa-arrow-to-bottom${iconsClassName ? ` ${iconsClassName}` : ""}`}
          onClick={() => downloadFile(file)}
        />
      )
    }
  }

  return (
    <div className={`document-actions-cell-renderer-container${className ? ` ${className}` : ""}`}>
      <i
        id={`documents-info-${rowIndex}`}
        className={`fal fa-info-circle${iconsClassName ? ` ${iconsClassName}` : ""}`}
        onClick={openPanel}
      />
      {renderOpenDownloadButton()}
    </div>
  )
}

export default DocumentActions
